import React from 'react';

import Grid from '@material-ui/core/Grid';

import Icon from 'react-web-vector-icons';

// estilos
import { Text, Divider } from './styled';
import './style.css';

// imagens
import logo from '../../images/home/logo-city-frase-reg-branco.png';
import logoUs from '../../images/home/logo-us.png';
import mediaQuery from '../common/mediaQuery';

export default ({ text, language }) => {
  const { small } = mediaQuery();

  return (
    <div
      className="Footer-wrapper"
      style={small ? { padding: '2vh', height: '70vh' } : {}}
    >
      <Grid
        container
        sm={12}
        justify="center"
        alignItems="center"
        className="Footer-grid"
      >
        <Grid container item sm={12} justify="center" alignItems="center">
          <img
            src={language === 'br' ? logo : logoUs}
            className="Footer-logo"
            alt=""
          />
        </Grid>

        <Grid
          container
          item
          sm={12}
          justify={small ? 'space-around' : 'center'}
          alignItems="center"
          style={
            small
              ? { marginTop: '6vh', marginBottom: '3vh' }
              : { marginTop: '3vh', marginBottom: '3vh' }
          }
        >
          <a
            href="https://www.facebook.com/CityConnectBROficial/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon
              name="facebook-f"
              font="FontAwesome"
              size={30}
              color="#fff"
              style={small ? { marginRight: 1 } : { marginRight: 30 }}
            />
          </a>

          <a
            href="https://www.linkedin.com/company/cityconnectbr/mycompany/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon
              name="linkedin"
              font="FontAwesome"
              size={30}
              color="#fff"
              style={small ? { marginRight: 1 } : { marginRight: 30 }}
            />
          </a>

          <a
            href="https://www.instagram.com/cityconnectbroficial/"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon
              name="instagram"
              font="FontAwesome"
              size={30}
              color="#fff"
              style={small ? { marginRight: 1 } : { marginRight: 30 }}
            />
          </a>
        </Grid>
        <Divider height="5vh" />
        <Divider width="80vw" height="2px" color="#58b711" />

        <Grid container item sm={8} justify="center" alignItems="center">
          <Divider height="3vh" />
          <Text weight="500" align={small ? 'justify' : 'left'}>
            {text.getTextoRodape()}
          </Text>
          <Divider height={small ? '10vh' : '5vh'} />
          <Text
            weight="500"
            size={small ? '12px' : '14px'}
            transform="uppercase"
            align={small ? 'center' : 'left'}
          >
            {text.getDireitosReservados()}
          </Text>
        </Grid>
      </Grid>
    </div>
  );
};
